import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';

import { environment } from '../../environments/environment';
import { SaudeResumoData } from '../models/resumo-saude';

export interface LoginTelefoneNascimentoRequest {
  telefone: string;
  dataNascimento: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private router: Router) {}

  async loginComTelefoneDataNascimento(
    dto: LoginTelefoneNascimentoRequest
  ): Promise<string> {
    const url = `${environment.apiUrl}/api/cindi/auth/login/${environment.cindiKind}`;

    return await axios
      .post(url, dto)
      .then((res) => {
        return res.data.data;
      })
      .catch((err: any) => {
        throw Error(err.response?.data?.message ?? 'Erro ao fazer login');
      })
      .finally(() => {});
  }

  saveToken(token: string) {
    sessionStorage.setItem('token', token);
  }

  logout() {
    sessionStorage.removeItem('token');
    this.router.navigate(['']);
  }

  isAuthenticated(): boolean {
    const token = sessionStorage.getItem('token');
    if (token && !this.isTokenExpired(token)) {
      return true;
    } else {
      this.logout();
      return false;
    }
  }

  private isTokenExpired(token: string): boolean {
    const expirationDate = this.getTokenExpirationDate(token);
    return expirationDate ? expirationDate <= new Date() : true;
  }

  private getTokenExpirationDate(token: string): Date | null {
    const decodedToken = this.decodeToken(token);
    if (decodedToken && decodedToken.exp) {
      const date = new Date(0);
      date.setUTCSeconds(decodedToken.exp);
      return date;
    }
    return null;
  }

  decodeToken(token: string): any {
    try {
      const payloadBase64 = token.split('.')[1];

      const payloadJson = decodeURIComponent(
        escape(
          atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'))
        )
      );

      return JSON.parse(payloadJson);
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return null;
    }
  }

  getUserName(): string {
    const token = sessionStorage.getItem('token');
    if (!token) {
      return '';
    }

    const decodedToken = this.decodeToken(token);
    const username = decodedToken?.nome || '';
    const firstName = username.split(' ')[0];
    return firstName;
  }

  getUserId(): number {
    const token = sessionStorage.getItem('token');
    if (!token) {
      return 0;
    }

    const decodedToken = this.decodeToken(token);
    const id = decodedToken?.id || 0;
    return id;
  }

}
